import { supabase } from '@/integrations/supabase/client';

export type PlaybookEvent = 'playbook_view' | 'playbook_buy_click' | 'playbook_sample_click' | 'playbook_sample_requested' | 'playbook_sample_download' | 'playbook_purchase_completed' | 'playbook_promo_click';

/** Fire-and-forget pseudonymous event in the existing insert-only homepage_events table. Clicks and completed sales are separate events. */
export function trackPlaybook(event: PlaybookEvent, label?: string) {
  try {
    let sid = sessionStorage.getItem('home_v2_sid');
    if (!sid) { sid = crypto.randomUUID(); sessionStorage.setItem('home_v2_sid', sid); }
    void supabase.from('homepage_events')
      .insert({ event_name: event, session_id: sid, label: label?.slice(0, 60) ?? null, variant: 'playbook_v1' })
      .then(() => undefined, () => undefined);
  } catch { /* never break the page */ }
}
